import { useTranslation } from '@core/translation';

export const useProfilePageTranslation = () => useTranslation('PROFILE');
